export default "__VITE_ASSET__Dtd1nEHY__"